/* unplugin-vue-components disabled */import script from "./ReceiveEmailSettingDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiveEmailSettingDialog.vue?vue&type=script&setup=true&lang=js"

import "./ReceiveEmailSettingDialog.vue?vue&type=style&index=0&id=ba6a8724&lang=less"
import "./ReceiveEmailSettingDialog.vue?vue&type=style&index=1&id=ba6a8724&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba6a8724"]])

export default __exports__